import requests from './request3';

import Qs from 'qs';

import { getCookie } from '@/utils/mycookie';
// 用户登录
export const listModel = (d) => requests({ url: '/model/list3', method: 'post', headers: { 'x-sid': JSON.parse(getCookie('user-inf'))?.user?.uar?.sid, 'x-codic': getCookie('x-myweb-key'), 'Content-Type': 'application/x-www-form-urlencoded' }, data: Qs.stringify(d, { indices: false }) });
